<input
  type="text"
  [class]="class"
  [ngClass]="{
    'ng-invalid': control?.invalid && control?.dirty,
    'ng-touched': control?.touched,
    'ng-dirty': control?.dirty,
  }"
  [placeholder]="officeField?.InputMask || ''"
  [mask]="inputMaskConfig?.pattern || null"
  [specialCharacters]="inputMaskConfig?.specialCharacters || []"
  [formControl]="innerControl"
  [name]="officeField.VistaFormItem.ColumnName"
  [maxlength]="inputMaskConfig?.inputLength || officeField.InputLength"
  (blur)="onBlur($event)"
  [thousandSeparator]="inputMaskConfig?.thousandSeparator || ''"
  [suffix]="inputMaskConfig?.suffix || ''"
  [prefix]="inputMaskConfig?.prefix || ''"
  [leadZero]="inputMaskConfig?.leadZero || null"
  [decimalMarker]="inputMaskConfig?.decimalMarker || null"
  [dropSpecialCharacters]="inputMaskConfig?.dropSpecialCharacters || false"
  [allowNegativeNumbers]="inputMaskConfig?.allowNegativeNumbers || null"
  [inputTransformFn]="inputTransformFn" />
